import React from 'react'
import DialogContent from '@mui/material/DialogContent';
import { createDraggablePaperComponent } from '../../dialog/DraggablePaper';
import EmpListContainer from '../../../../containers/common/form/modal/EmpListContainer'
import BootstrapDialog, { BootstrapDialogTitle } from '../../dialog/BootstrapDialog'

const PaperComponent = createDraggablePaperComponent('draggable-emp-dialog');

const EmpModal = ({ roleTyp, title, multi, open, handleClose, selectedEmployee }) => {
    return (
        <BootstrapDialog
            open={open}
            onClose={handleClose}
            PaperComponent={PaperComponent}
            aria-labelledby="draggable-emp-dialog"
            fullWidth={true}
            maxWidth="md"
        >
            <BootstrapDialogTitle style={{ cursor: 'move' }} id="draggable-emp-dialog" onClose={handleClose}>
                {title}
            </BootstrapDialogTitle>
            <DialogContent dividers>
                <EmpListContainer roleTyp={roleTyp} multi={multi} selectedEmployee={selectedEmployee} handleClose={handleClose} />
            </DialogContent>
        </BootstrapDialog>
    )
}

export default EmpModal